import { ModuleWithProviders, NgModule } from '@angular/core';
import { DataRetrieverHttpService } from '@data-api/services/data-retriever-http.service';
import { CacheHttpService } from '@data-api/services/cache-http.service';

@NgModule({})
export class DataApiModule {
  static forRoot(): ModuleWithProviders<DataApiModule> {
    return {
      ngModule: DataApiModule,
      providers: [DataRetrieverHttpService, CacheHttpService],
    };
  }
}
